import { z } from "zod";
import { FormInstructionCompilationSchema, FormInstructionCompileInputSchema, FormInstructionInputSchema, ReviewedFormInstructionOverrideSchema, } from "./form-instructions.js";
/**
 * Test-fill explanations normally name a field by its fieldId. Two prefixes mark entries that
 * are not fields: a test the instructions would propose ("proposal:<test id>"), and a note
 * about the whole sample whose remaining text is its plain heading ("note:<form name>").
 */
export const FORM_TEST_FILL_PROPOSAL_PREFIX = "proposal:";
export const FORM_TEST_FILL_NOTE_PREFIX = "note:";
export const FormTestFillSchema = z.object({
    id: z.string().uuid(),
    configurationHash: z.string(),
    compilationHash: z.string().regex(/^sha256:[0-9a-f]{64}$/),
    pdfBase64: z.string().min(1),
    contentHash: z.string(),
    includedPageNumbers: z.array(z.number().int().positive()).min(1),
    explanations: z.array(z.object({ fieldId: z.string(), reason: z.string(), value: z.string() })),
    issues: z.array(z.string()),
    createdAt: z.string(),
});
export const FormConfigurationSchema = z.object({
    id: z.string().uuid(),
    documentId: z.string().uuid().nullable(),
    documentVersion: z.number().int().positive().nullable(),
    versionHash: z.string().nullable(),
    mappingIdentityHash: z.string().nullable(),
    revision: z.number().int().positive(),
    status: z.enum(["needs_review", "draft", "published"]),
    includedPageNumbers: z.array(z.number().int().positive()),
    pagesConfirmed: z.boolean(),
    instructions: z.array(FormInstructionInputSchema),
    reviewedOverrides: z.array(ReviewedFormInstructionOverrideSchema).default([]),
    compilation: FormInstructionCompilationSchema.nullable(),
    compileInput: FormInstructionCompileInputSchema.nullable(),
    testFill: FormTestFillSchema.nullable(),
    contentHash: z.string(),
    updatedAt: z.string(),
});
export const FormProcessingJobSchema = z.object({
    id: z.string().uuid(),
    documentId: z.string().uuid(),
    documentVersion: z.number().int().positive(),
    status: z.enum(["running", "completed", "failed"]),
    attempts: z.number().int().positive(),
    error: z.string().nullable(),
    updatedAt: z.string(),
});
export const FormAdministrationSnapshotSchema = z.object({
    enabled: z.boolean(),
    processingJobs: z.array(FormProcessingJobSchema).optional(),
    configurations: z.array(FormConfigurationSchema),
    clinicInstructions: FormConfigurationSchema.nullable(),
});
export const FormInstructionOverrideInputSchema = ReviewedFormInstructionOverrideSchema.omit({
    reviewedBy: true,
    reviewedAt: true,
});
//# sourceMappingURL=form-administration.js.map